import { useTheme } from '@mui/material/styles';
import type { V4Theme } from '@packages/themes/v4';
import { createMakeStyles } from 'tss-react';

const { makeStyles } = createMakeStyles<V4Theme>({
  useTheme,
});

export { makeStyles };
